export default __webpack_public_path__ + "static/media/Python.0a085f2c.png";